import { IS_PRODUCTION } from "src/shared/utils/env";

export type SponsorAuthMode = "login" | "signup";

const MY_HOST = !IS_PRODUCTION
  ? "release-staging--my-hackthenorth-com.netlify.app"
  : "my.hackthenorth.com";

export const getSponsorAuthUrl = (
  inviteCode: string,
  mode: SponsorAuthMode
): string => {
  const path = mode === "signup" ? "/signup" : "/";
  const staging = !IS_PRODUCTION ? "&staging" : "";
  return `https://auth.hackthenorth.com${path}?redirect=${MY_HOST}&r=sponsor&sc=${inviteCode}${staging}`;
};
